import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { useHasPermission } from "hooks/useHasPermission";
import { getExportEmployeeData } from "../../../redux/slice/getExportEmployeeDataSlice";

const EmployeeReportPage = () => {
  const dispatch = useDispatch();
  const canViewExportCandidate = useHasPermission("Export Employee Data-view");
  console.log("canViewExportCandidate", canViewExportCandidate);
  const [isOpen, setIsOpen] = useState(true);
  const [exportStatus, setExportStatus] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const employeeTypes = [
   {key: null, value:"All Employee"},
   { key:"ACTIVE", value:"Active"},
   { key:"EXITED", value:"Exited"},
    {key:"PERMANENT", value:"Permanent"},
    {key:"CONTRACTUAL", value:"Contractual"},
   { key:"PROBATION", value:"Probation"},
    {key:"TRAINEE", value:"Trainee"},
    {key:"INTERN", value:"Intern"},
  ];
const [selectedFilter, setSelectedFilter] = useState(employeeTypes[0]);
  const handleExport = async () => {
    if (!canViewExportCandidate) {
      toast.error("You don't have permission to export data", {
        className: "toast-error-custom",
        autoClose: 5000,
      });
      return;
    }
const payload = {
      employeeType: selectedFilter.key,
      duration: {
        from: fromDate ? `${fromDate}T00:00:00` : null,
        to: toDate ? `${toDate}T23:59:59` : null,
      },
    };

    console.log("employeeExportPayload", payload);

    try {
      await dispatch(getExportEmployeeData(payload)).unwrap();
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  return (
    <div className="container w-100 py-4">
      <div className="p-3 shadow-sm rounded border bg-white w-100">
        <div className="row g-3 align-items-center justify-content-between">
          <div className="col-12 col-lg-4">
            <Dropdown className="w-100">
              <Dropdown.Toggle
                variant="light"
                className="border-0 shadow w-100 d-flex justify-content-between align-items-center"
                style={{ backgroundColor: "#dae0e5", color: "black" }}
                id="dropdown-employee-type"
              >
                <span className="text-truncate pe-2">{selectedFilter.value}</span>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="shadow border-0 w-100"
                style={{ borderRadius: "10px" }}
              >
                {employeeTypes.map((type, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={() => setSelectedFilter(type)}
                  >
                    {type.value}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="col-12 col-lg-auto ms-lg-auto text-end">
            <button
              className="primary-btn btn btn-primary px-4 py-2 shadow-sm w-100"
              onClick={handleExport}
            >
              Export
            </button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default EmployeeReportPage;
